import { useState } from "react";
import AppNavDropdown from "./AppNavDropdown";
import { ReactComponent as SalesIcon } from "../../assets/img/nav/metrics.svg";
import { ReactComponent as RewardIcon } from "../../assets/img/nav/product-updates.svg";
import { useStores } from "store/useStore";
import { useCallback } from "react";

/**
 * Dropdown for app navigation
 */
const AppNavRewards = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { uiStore } = useStores();

  const toggle = useCallback(() => uiStore.createRewardDialog.toggle(), [
    uiStore,
  ]);

  return (
    <div
      className="sidebar-nav-item cursor-pointer mr-3"
      onClick={() => setIsOpen(!isOpen)}
    >
      <span>
        <span className="main-bar-nav-item">
          Rewards
          <div className="ml-2 caret" />
        </span>
        <AppNavDropdown
          className="mt-0 main-bar-nav-item-manage"
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          placement={"bottom-start"}
          options={[
            {
              contents: (
                <>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "auto 1fr",
                      gap: "0px",
                      alignItems: "start",
                    }}
                  >
                    <RewardIcon className="nav-icon mt-1" />
                    <span>
                      <span>Get 1,000 bonus subscribers</span>
                      <div
                        style={{ fontSize: "12px" }}
                        className="text-gray-500 p-0 m-0 mt-1"
                      >
                        Refer a friend. When they sign up to Encharge, you get
                        1,000 bonus subscribers
                      </div>
                    </span>
                  </div>
                </>
              ),
              onClick: toggle,
            },
            {
              contents: (
                <>
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "auto 1fr",
                      gap: "0px",
                      alignItems: "start",
                    }}
                  >
                    <SalesIcon className="nav-icon mt-1" />
                    <span>
                      <span>Earn up to 50% of sales</span>
                      <div
                        style={{ fontSize: "12px" }}
                        className="text-gray-500 p-0 m-0 mt-1"
                      >
                        Join our affiliate program. Earn up to 50% of the sales
                        you're bringing
                      </div>
                    </span>
                  </div>
                </>
              ),
              href: "https://encharge.io/affiliate-program",
            },
          ]}
        />
      </span>
    </div>
  );
};
export default AppNavRewards;
